import React, { useContext, useState } from 'react';
import parse from 'html-react-parser';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import { MapSection } from './styles/ContactLocationBlock.styled';
import { DWTCContext } from '../utils/context';
import { getTranslationByKey } from '../helpers/translation-helper';
import { Container } from './styles/Container.styled';
import {
  ThreeColumnIntroBlockSection,
  ArticlePart,
  ArticleH3,
  ArticleParagraph,
  TextWrapper,
  ReadMoreLabel,
} from './styles/ThreeColumnIntroBlock.styled';
import { IframeMap } from './styles/IFrameMap.styled';
import useMediaQuery from '../hooks/useMediaQuery';

export default function ThreeColumnTextContent({ data, id, dir, markericon }) {
  const [toggleText, setToggleText] = React.useState(false);
  const isArabic = dir === 'rtl';

  const { translations } = useContext(DWTCContext);

  const textLess = getTranslationByKey(translations, '-Read Less');
  const textMore = getTranslationByKey(translations, '+Read More');

  const [label, setLabel] = React.useState(textMore);
  React.useEffect(() => setLabel(toggleText ? textLess : textMore), [toggleText]);

  const pins = [];

  if (data.transportItems) {
    data.transportItems.forEach((item) => {
      const transportItem = item;

      const locationArray = item.content.location.split(',');
      const lt = parseFloat(locationArray[0]);
      const ln = parseFloat(locationArray[1]);

      const center = {
        lat: lt,
        lng: ln,
      };

      transportItem.center = center;

      pins.push(transportItem);
    });
  }
  const mapStyles = [
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
  ];

  const containerStyle = {
    width: '100%',
    height: '100%',
  };

  const matches = useMediaQuery('(min-width: 576px)');

  const [infoDetails, setInfoDetails] = useState(null);

  const variants = {
    hidden: { opacity: 0, y: -100, height: 0 },
    visible: { opacity: 1, y: 0, height: 'auto' },
  };

  const handleAnimate = () => {
    if (matches) {
      return 'visible';
    }
    return toggleText ? 'visible' : 'hidden';
  };

  return (
    <ThreeColumnIntroBlockSection id={id}>
      <Container>
        <ArticlePart>
          <ArticleH3 className="threecolumnh3" dir={dir}>
            {data.description[0]}
          </ArticleH3>
          <ArticleParagraph>
            <TextWrapper>{data.description[1]}</TextWrapper>
            {data.description.map(
              (value, index) =>
                index > 1 && (
                  <TextWrapper
                    dir={dir}
                    variants={variants}
                    animate={handleAnimate()}
                    initial={matches ? 'visible' : 'hidden'}
                    transition={{ duration: 0.8, ease: 'linear' }}
                    toggle={toggleText}
                    className="toggle"
                  >
                    {parse(value)}
                  </TextWrapper>
                ),
            )}
          </ArticleParagraph>
          <ReadMoreLabel toggle={toggleText} onClick={() => setToggleText(!toggleText)} dir={dir}>
            {label}
          </ReadMoreLabel>
        </ArticlePart>
      </Container>

      {data.transportItems ? (
        <MapSection dir={dir} className="getting_heremap">
          <IframeMap dir={dir}>
            <LoadScript
              language={isArabic ? 'ar' : 'en'}
              googleMapsApiKey={process.env.GATSBY_GOOGLE_API_KEY}
            >
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={pins[0].center}
                options={{ styles: mapStyles }}
                zoom={16}
              >
                {pins.map((item, index) =>
                  markericon ? (
                    <Marker
                      key={index}
                      className="marker"
                      icon={markericon?.url}
                      position={item.center}
                      onClick={() => {
                        setInfoDetails(item);
                      }}
                    />
                  ) : null,
                )}

                {infoDetails && (
                  <InfoWindow
                    onCloseClick={() => {
                      setInfoDetails(null);
                    }}
                    position={infoDetails.center}
                  >
                    <div style={{ fontSize: 13, textAlign: 'center', fontWeight: 400 }}>
                      <div style={{ marginBottom: 5 }} className="map-text" dir={dir}>
                        {infoDetails.content.title}
                      </div>
                      <a
                        href={`https://www.google.com/maps/search/?api=1&query=${infoDetails.content.location}`}
                        target="_blank"
                        rel="noreferrer nofollow"
                        className="card-board-link"
                        tabIndex="0"
                      >
                        {getTranslationByKey(translations, 'View on Google Maps')}
                      </a>
                    </div>
                  </InfoWindow>
                )}
              </GoogleMap>
            </LoadScript>
          </IframeMap>
        </MapSection>
      ) : null}
    </ThreeColumnIntroBlockSection>
  );
}
